/**
 * tRPC React Query client for type-safe API calls.
 * Client configuration is done in App.tsx; this exports the typed client.
 */
import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@unios/api/src/trpc/router";

/**
 * tRPC React client
 *
 * Imports AppRouter type from the API package for full type safety.
 * The actual client configuration is done in App.tsx.
 */
export const trpc = createTRPCReact<AppRouter>();
